// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:768px){.categorias-wrapper::-webkit-scrollbar{width:0!important;height:0!important;background:transparent!important;display:none!important}.categorias-wrapper{scrollbar-width:none!important;-ms-overflow-style:none!important;margin-bottom:20px}}", ""]);
// Exports
module.exports = exports;
